import { useId, useLayoutEffect, useRef } from 'react'
import { X } from 'lucide-react'
import { Dialog, DialogContent, DialogDescription, DialogTitle } from 'components/ui/dialog'
import { setForegroundPromptBlocker } from 'utils/foregroundPrompt'
import { ForNextTimePanel, type ForNextTimePanelHandle, type ForNextTimePanelProps } from './ForNextTimePanel'

export type ForNextTimeDialogProps = ForNextTimePanelProps & {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function ForNextTimeDialog({ open, onOpenChange, ...panelProps }: ForNextTimeDialogProps) {
  const panelRef = useRef<ForNextTimePanelHandle>(null)
  const promptBlockerId = useId()
  useLayoutEffect(() => {
    if (!open) return
    setForegroundPromptBlocker(promptBlockerId, true)
    return () => setForegroundPromptBlocker(promptBlockerId, false)
  }, [open, promptBlockerId])
  const close = () => panelRef.current ? panelRef.current.requestClose(() => onOpenChange(false)) : onOpenChange(false)
  return <Dialog open={open} onOpenChange={next => { if (next) onOpenChange(true); else close() }}>
    <DialogContent className="continuity-dialog" overlayClassName="continuity-dialog-overlay" hideCloseButton>
      <header className="continuity-dialog-header"><div><DialogTitle>For next time</DialogTitle><DialogDescription className="sr-only">Your relationship’s recap, ongoing topics, and agreed actions.</DialogDescription></div><button type="button" className="continuity-icon-button" aria-label="Close relationship notes" onClick={close}><X size={20} aria-hidden="true" /></button></header>
      <ForNextTimePanel {...panelProps} ref={panelRef} />
    </DialogContent>
  </Dialog>
}
